import moment from 'moment'

export const EMPTY_CUPO = {
  fechaDeCupo: moment(Date.now()).format('YYYY/MM/DD'),
  fechaD: moment(Date.now()).format('YYYY/MM/DD'),
  fechaH: moment(Date.now()).format('YYYY/MM/DD'),
  // repetirNominacionHasta: moment(Date.now()).format('YYYY/MM/DD'),
  exportador: '',
  'Tipo de Cupo': 'UNDEF',
  cantidad: '0',
  cantidadNominada: '0',
  cereal: 'UNDEF',
  notificarPorCorreo: true,
  enviarATodos: true,
  contactosSeleccionados: null
}

export const EMPTY_CUPO_NOMINACION = {
  cantidadRenominada: ''
}

export const EMPLY_BLOQUEO_CUPO = {
  fechaD: moment(Date.now()).format('YYYY/MM/DD'),
  fechaH: moment(Date.now()).format('YYYY/MM/DD'),
  cereal: [],
  exportador: [],
  bloqueoTotal: true
}

export const EMPLY_CUPOS_NOMINADOS = {
  fechaD: moment(Date.now()).format('YYYY/MM/DD'),
  fechaH: moment(Date.now()).format('YYYY/MM/DD')
}

export const EMPLY_CUPOS_ADELANTO = {
  cereales: [],
  fechaD: moment(Date.now()).format('DD/MM/YYYY'),
  fechaH: moment(Date.now()).add(1, 'days').format('DD/MM/YYYY'),
  horaAdelanto: moment(Date.now()).add(1, 'hours').format('HH:mm')
}
